import { Button, Col, Modal, Row, Space, Typography, theme } from "antd";
import React from "react";
import BinIcon from "../../assets/images/icon/binIcon.svg";
import SaveIcon from "../../assets/images/icon/saveIcon.svg";
const { Title, Text } = Typography;

const { useToken } = theme;

const ConfirmModal = ({
  title,
  modalText,
  open,
  onOk,
  confirmLoading,
  onCancel,
  actionType,
}) => {
  const { token } = useToken();

  const handleCancel = () => {
    onCancel();
  };

  return (
    <Modal
      centered
      title={""}
      open={open}
      onOk={onOk}
      confirmLoading={confirmLoading}
      onCancel={onCancel}
      footer={false}
      width={400}
    >
      <Space
        direction="horizontal"
        style={{ width: "100%", justifyContent: "center", marginTop: 30 }}
      >
        <img
          src={actionType === "delete" ? BinIcon : SaveIcon}
          width={90}
          height={90}
          alt="Confirm Icon"
        />
      </Space>

      <Row justify="center">
        <Col span={24} align="center">
          <Title level={5} style={{ marginTop: 20 }}>
            {title}
          </Title>
        </Col>
        <Col span={24} align="center">
          <Text className="sub-title">{modalText}</Text>
        </Col>
      </Row>

      <Space
        direction="horizontal"
        style={{ width: "100%", justifyContent: "center", margin: "20px 0" }}
      >
        <Button
          key="back"
          onClick={handleCancel}
          style={{ color: token.colorSecondary }}
        >
          ยกเลิก
        </Button>
        <Button
          key="back"
          onClick={onOk}
          style={{ backgroundColor: token.thPrimary, color: "white" }}
        >
          {actionType === "delete" ? "ลบ" : "ตกลง"}
        </Button>
      </Space>
    </Modal>
  );
};

export default ConfirmModal;
